import { createGlobalStyle } from 'styled-components';
import { colorText } from '@spark/ui-components/theme';
import { left, right } from '@spark/ui-components/theme';
const NotificationStyles = createGlobalStyle`
  [data-spark-notification-host='true'] {
    position: fixed !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 0 !important;
    pointer-events: none !important;
    z-index: 2000 !important;
  }

  .rc-notification {
    position: fixed !important;
    ${left}: auto !important;
    ${right}: 0 !important;
    top: 60px !important;
    height: auto !important;
    width: auto !important;
    max-width: 360px;
    margin: 0 !important;
    padding: 0 !important;
    pointer-events: none !important;
    z-index: 2000 !important;
  }

  .rc-notification > span {
    display: block;
    pointer-events: none !important;
  }

  .rc-notification-notice {
    display: block;
    width: auto;
    max-width: 360px;
    line-height: 1.5;
    position: relative;
    pointer-events: auto;
  }

  /* Leave fora do fluxo: transform/opacity sozinho mantinha altura e
     empurrava o proximo toast para a ultima posicao da pilha. */
  .rc-notification-fade-leave,
  .rc-notification-fade-leave-active,
  .rc-notification-notice.rc-notification-fade-leave {
    position: absolute !important;
    ${right}: 0 !important;
    ${left}: auto !important;
    top: 0 !important;
    height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
    visibility: hidden !important;
  }

  .rc-notification-notice-close {
    position: absolute;
    ${right}: 18px;
    top: 8px;
    font-size: 18px;
    line-height: 1;
    font-weight: 400;
    color: ${colorText};
    text-shadow: none;
    opacity: 0.4;
    pointer-events: auto;
    z-index: 2;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
    cursor: pointer;
    outline: none;
    text-decoration: none;

    &:hover {
      opacity: 0.8;
      color: ${colorText};
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .rc-notification-notice-close-x:after {
    content: '×';
  }
`;
export default NotificationStyles;
